import { Skeleton } from '@chakra-ui/react';

export const GameLoader = () => {
	return (
		<Skeleton
			opacity="0.3"
			width="180px"
			h="100%"
		></Skeleton>
	);
};
